const RANKS = require("../configs/ranks");

module.exports = ($, M) => {
  let isProfileLoaded = false;

  // Headless version (hidden header and footer) support
  const urlParams = new URL(window.location.href).searchParams;
  if (urlParams.get("headless") !== null) {
    $("body").addClass("headless");
  }

  /**
   * Profile dropdown
   */
  const $profileInner = $(".header-profile-inner");
  const $profileDetails = $(".profile-details");
  const $headerInfoCard = $(".header-info-card");
  const $dropdownArrow = $(".header-dropdown-arrow");

  function toggleProfileDropDown() {
    $profileInner.toggleClass("is-active");
    $headerInfoCard.toggleClass("is-active");
    $dropdownArrow.toggleClass("is-active");

    if (!isProfileLoaded) {
      $.get("/ajax/user/profile/", (resp) => {
        resp.user = M.user.username;
        const html = M.renderer.render("header-profile-content", resp);
        $profileDetails.html(html);
        animateProgressBar();
      });
      isProfileLoaded = true;
    }
  }

  function animateProgressBar() {
    const $profileProgressBar = $(".js-progress-bar");
    const progress = $profileProgressBar.attr("data-progress");
    $profileProgressBar.animate({
      width: `${progress * 100}%`,
    });
  }

  function openRankBadgesModal() {
    const ranks = RANKS.map((rank, index) => {
      const name = rank.id.charAt(0).toUpperCase() + rank.id.slice(1);
      const gloss = _t(`rank_gloss_${rank.id}`);

      return {
        img: `${M.STATIC_URL}img/icons/ranks/${index + 1}_outline_v2.svg?rebrand2019`,
        name,
        gloss,
        showGloss: gloss.toLowerCase() !== name.toLowerCase(),
        points: rank.points,
      };
    });

    M.modal.content({
      template: "rank-badges",
      showHeader: true,
      headerText: _t("rank_badges_modal_title"),
      templateVars: { ranks },
      modalId: "rank-badges-modal",
      removeOnHidden: true,
    });
  }

  $profileDetails.on("click", ".js-rank-info-toggle", (e) => {
    e.stopPropagation();
    openRankBadgesModal();
  });

  $(".js-info-toggle").on("click", (e) => {
    toggleProfileDropDown();
    e.stopPropagation(); // needed for document click
  });

  $(document).on("click", (e) => {
    if (
      $profileInner.hasClass("is-active") &&
      $(e.target).closest("ul")[0] !== $profileInner[0]
    ) {
      toggleProfileDropDown();
    }
  });
};
